import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import Typography from "@material-ui/core/Typography"

import Textarea from "../components/textarea"
import FlexibleContent from "../components/_flexibleContent"

export default function home({ data }) {
  const {
    wordsbyCollections: {
      acf: { content_collection },
      post_title,
      post_content,
      pathname
    }
  } = data
  return (
    <Container>
      {/* {!!post_title && (
        <Typography variant="h1" gutterBottom>
          {post_title}
        </Typography>
      )} */}

      {!!post_content && (
        <>
          <Typography variant="h3" gutterBottom />
          <Textarea content={post_content} />
        </>
      )}

      {!!content_collection && (
        <FlexibleContent
          rows={content_collection}
          data={{
            post_title,
            pathname
          }}
        />
      )}
    </Container>
  )
}
const Container = styled.div``

export const CollectionQuery = graphql`
  query DefaultTemplate($id: Int!) {
    wordsbyCollections(ID: { eq: $id }) {
      post_title
      post_content
      pathname
      acf {
        content_collection {
          ...flexibleContent
        }
      }
    }
  }
`
